import styled, { keyframes } from 'styled-components/macro';

const rotate = keyframes`
	0% {
		transform: rotate(0)
	}
	
	100% {
		transform: rotate(360deg)
	}
`;

const move1 = keyframes`
	0%,
	5% {transform: translate(0, 0);}
	to {transform: translate(0, -100%);}
`;

const move2 = keyframes`
	0%,
	5% {
		transform: translate(0, 0);
	}
	to {
		transform: translate(100%, 100%);
	}
`;

const move3 = keyframes`
	0%,
	15% {
		transform: translate(0);
	}
	to {
		transform: translate(-100%, 100%);
	}
`;

// const move4 = keyframes`
// 	0%,
// 	20% {
// 		transform: translate(0);
// 	}
// 	to {
// 		transform: translate(150%, -150%);
// 	}
// `;

// const move5 = keyframes`
// 	0%,
// 	25% {
// 		transform: translate(0);
// 	}
// 	to {
// 		transform: translate(150%, 150%);
// 	}
// `;

export const Container = styled.div`
	height: 100vh;
	width: 100vw;
	margin: auto;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction:column;
	background: linear-gradient(180deg, #EEE 13.89%, #FFF 100%);
`;

export const WrapLoad = styled.div`

margin-top:40px;
`

export const LoadingWrapper = styled.div`
	animation: ${rotate} 1s linear infinite normal;
	animation-duration: 1s;
	animation-iteration-count: infinite;
	height: 0.8rem;
	position: relative;
	width: 0.8rem;
`;

export const Ball = styled.div`
	animation-name: ${move1};
	animation-duration: 0.5s;
	animation-direction: alternate;
	animation-timing-function: ease-in-out;
	animation-iteration-count: infinite;
	background-color: #194186;
	border-radius: 50%;
	height: 100%;
	position: absolute;
	width: 100%;

	&:nth-of-type(2) {
		animation-name: ${move2};
	}

	&:nth-of-type(3) {
		animation-name: ${move3};
	}



`;
